import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzSegmentedOption } from './sz-segmented-option.type';

@Component({
  selector: 'sz-segmented',
  templateUrl: './sz-segmented.component.html',
  styleUrls: ['./sz-segmented.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzSegmentedComponent<T> {
  readonly options: InputSignal<ReadonlyArray<SzSegmentedOption<T>>> =
    input.required<ReadonlyArray<SzSegmentedOption<T>>>();
  readonly value: InputSignal<T | null> = input<T | null>(null);
  readonly mono: InputSignal<boolean> = input<boolean>(false);
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly valueChange: EventEmitter<T> = new EventEmitter<T>();

  select(value: T): void {
    if (this.disabled() || value === this.value()) {
      return;
    }
    this.valueChange.emit(value);
  }
}
